module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内待入库",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内入库",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已合箱",
      "name": "6"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内出库",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心出库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分舵入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "客户签收",
      "name": "five"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "six"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待补录",
      "name": "seven"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.activeName != 8) ? _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "合箱编码",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "用户VIP号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "vipCode", $$v)
      },
      expression: "search.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "派送点",
      "clearable": ""
    },
    on: {
      "change": _vm.selectAddress,
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "deliveryTitle", $$v)
      },
      expression: "search.deliveryTitle"
    }
  }, _vm._l((_vm.deliverArr), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.deliveryTitle
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "货物类型",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("合箱时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.value1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcelBox()
      }
    }
  }, [_vm._v("导出箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportOrderToExcel()
      }
    }
  }, [_vm._v("导出订单")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "row-key": "boxId",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.vipCodes || '').split(',').length > 1) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s((scope.row.vipCodes || "").split(",").length > 1 ? "混" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.boxNumber) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "batchNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left",
      "min-width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', _vm._l((_vm.deliverArr), function(delivalue, indexs) {
          return _c('h5', {
            key: indexs
          }, [_c('h5', [_vm._v("\n                " + _vm._s(delivalue.addressId === scope.row.addressId ?
            delivalue.deliveryTitle :
            "") + "\n              ")])])
        }), 0), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "80px"
    }
  }, [_vm._v("\n        已合箱\n      ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合箱时间",
      "align": "center",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.toDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHanlder(scope.row)
            }
          }
        }, [_vm._v("出库")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.cancelBox(scope.row)
            }
          },
          slot: "reference"
        }, [_vm._v("撤销")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.outHanlder(null)
      }
    }
  }, [_vm._v("批量出库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.multiPrint
    }
  }, [_vm._v("批量打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("X100000001")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("Toronto")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("2021-03-09 12:23:21")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("待入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("预估费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD 19.88")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户VIP号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("A100009")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("商品入库数据 （每件商品数据）")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list,
      "show-header": false,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.outDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.outDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.outDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.outSubmit()
      }
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (!_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchOutSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.outDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("货物类型：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ?
    _vm.goodType(_vm.detailDialog.boxInfo.goodType) :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户VIP号：")]), _c('span', {
    staticClass: "l_value2"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.vipCodes : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                  " + _vm._s(scope.row.goodName) + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "width": "80px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "70px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', {
          staticClass: "status1"
        }, [_vm._v("待入库")]) : (scope.row.status == 2) ? _c('span', {
          staticClass: "status2"
        }, [_vm._v("已入库")]) : (scope.row.status == 3) ? _c('span', {
          staticClass: "status3"
        }, [_vm._v("已出库")]) : (scope.row.status == 4) ? _c('span', {
          staticClass: "status4"
        }, [_vm._v("已结单")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "status-1"
        }, [_vm._v("已取消")]) : (scope.row.status == 6) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("已合箱")]) : (scope.row.status == 7) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("(中心仓)已入库")]) : (scope.row.status == 8) ? _c('span', {
          staticClass: "status8"
        }, [_vm._v("(中心仓)已出库")]) : (scope.row.status == 9) ? _c('span', {
          staticClass: "status9"
        }, [_vm._v("(派送)已入库")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(CAD)",
      "prop": "total",
      "width": "95px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "addTime",
      "width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss")) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "100px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), (_vm.mianDialog.show) ? _c('Face', {
    attrs: {
      "boxId": _vm.faceOrderList
    },
    on: {
      "closeFaceDialog": _vm.closeFaceDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f09e795c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/boxOrderList.vue
// module id = 1267
// module chunks = 2